import getters from './getters'
import mutations from './mutations'
import actions from './actions'

export default {
  state: {
    customers: [],
    settings: {
      visibleColumns: [''],
    },
    customer: null,
    customerErrors: null,
    customerFilters: null,
    customersCounter: 0,
    customerLogs: null,
    customerVisits: [],
    customerBookings: null,
    customerSipHistory: null,
  },
  getters: getters,
  mutations: mutations,
  actions: actions,
}
